document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header");
  const scrollThreshold = 0;

  function handleScroll() {
    if (window.scrollY > scrollThreshold) {
      header.classList.add("header--shadow");
    } else {
      header.classList.remove("header--shadow");
    }
  }

  // Initial check
  handleScroll();

  // Add scroll listener
  window.addEventListener("scroll", handleScroll, { passive: true });

  // Optional: Use Intersection Observer for better performance
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          header.classList.add("header--shadow");
        } else if (window.scrollY < scrollThreshold) {
          header.classList.remove("header--shadow");
        }
      });
    },
    {
      threshold: [0, 1],
      rootMargin: `-${scrollThreshold}px 0px 0px 0px`,
    }
  );

  observer.observe(header);
});
